import type { ImageDetails } from "proto/image";
import type { Banner } from "proto/shopfront";

import { BehaviorSubject } from "rxjs";

export const BannerType = {
	Small: 'small',
	Large: 'large',
	Deluxe: 'deluxe',
}
export type BannerTypeOption = typeof BannerType[keyof typeof BannerType];

export interface DisplayBanner extends Banner {
	display: {
		additional_data: string,
		url_title: string,
		main_image: ImageDetails,
		title: string,
		url: string
	},
	ids?: number[],
	sub_type: string
}

export interface BannerArrays {
	small?: DisplayBanner[],
	large?: DisplayBanner[],
	deluxe?: DisplayBanner[],
}

const _deluxe$ = new BehaviorSubject<DisplayBanner[] | null>(null);
export const deluxe$ = _deluxe$.asObservable();

export function setDeluxeBanner(banners: DisplayBanner[]) {
	_deluxe$.next(banners);
	_deluxe$.next(null);
	// _deluxe$.complete();
}